export default "__VITE_ASSET__W597GKXQ__"